import { Box } from 'reflexbox';

import * as graphql from 'generated/graphql';

import { CompetencyDisplayWithValue } from './CompetencyDisplay';
import PlaceholderDisplay from './PlaceholderDisplay';
import QuillText from 'packages/kakapo-ui-kit/components/editors/QuillText';

export default function ReviewGoalsDisplay(props: {
	form: graphql.EvaluationSectionItem;
	item: graphql.EvaluationSubmissionItem;
	metadata: { goal: graphql.EvaluationSubmissionGoal };
}) {
	const { goal } = props.metadata;

	const review = props.item.reviewGoals?.find((review) => review.goalID === goal.goal.id);

	if (!review || (review.competency === null && review.text.ops.length === 0)) {
		return <PlaceholderDisplay />;
	}

	return (
		<>
			<Box my={2}>
				<CompetencyDisplayWithValue
					levels={props.form.reviewGoals!.competencyLevelSet.levels.map((level) => ({
						enabled: true,
						level,
					}))}
					score={{ employee: review.competency ?? undefined }}
					party={graphql.EvaluationSubmissionParty.Employee}
				/>
			</Box>
			<Box>
				<QuillText quill={review.text} />
			</Box>
		</>
	);
}
